export default String.raw`
@charset "UTF-8";

/* ---- globals ---- */
@import 'globals/_global-variables';
@import 'globals/_globals-m';
`